import api from './config';

export const startThirtyDaysChallenge = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/activity/${activityId}/challenge/start`, {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data.id;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const stopThirtyDaysChallenge = async (activityId, challengeId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.post(`/activity/${activityId}/challenge/${challengeId}/stop`, {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getChallengeHistory = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get(`/activity/${activityId}/challenge/history`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}; 